<template>
	<div class="container">
		<div class="row">
			<div class="col-sm-12" v-cloak>
			<stepButtons v-if="!opignoMode"></stepButtons>
				<stepDisplay></stepDisplay>
				<div v-if="auditNotFinished">
					<explanationBlock></explanationBlock>
					<patientsBlock v-if="isFirstOrSecondStep"></patientsBlock>
					<criteriaQuestionBlock :current-criteria-percentage-of-yes="currentCriteriaPercentageOfYes" ></criteriaQuestionBlock>
					<answersBlock :current-criteria-percentage-of-yes="currentCriteriaPercentageOfYes" :is-first-or-second-step="isFirstOrSecondStep" ></answersBlock>
					<switchButtons :is-first-or-second-step="isFirstOrSecondStep" ></switchButtons>
					<progressBarBlock v-if="!opignoMode"></progressBarBlock>
				</div>
				<div v-else>
					<statisticsResultsBlock :user="true" :group="true" ></statisticsResultsBlock>
				</div>
			</div>
		</div>
		<modalStartTrainingBlock></modalStartTrainingBlock>
		<modalStatisticsBlock></modalStatisticsBlock>
	</div>
</template>

<script>
	import StepButtons from 'components/StepButtons';
	import ExplanationBlock from 'components/ExplanationBlock';
	import PatientsBlock from 'components/PatientsBlock';
	import CriteriaQuestionBlock from 'components/CriteriaQuestionBlock';
	import AnswersBlock from 'components/AnswersBlock';
	import SwitchButtons from 'components/SwitchButtons';
	import ProgressBarBlock from 'components/ProgressBarBlock';
	import StatisticsResultsBlock from 'components/StatisticsResultsBlock';
	import StepDisplay from 'components/StepDisplay';
	import ModalStartTrainingBlock from 'components/ModalStartTrainingBlock';
	import ModalStatisticsBlock from 'components/ModalStatisticsBlock';
	import { modal as Modal } from 'vue-strap';

	export default {
		components: {
			StepButtons,
			ExplanationBlock,
			PatientsBlock,
			CriteriaQuestionBlock,
			AnswersBlock,
			SwitchButtons,
			ProgressBarBlock,
			StatisticsResultsBlock,
			StepDisplay,
			ModalStartTrainingBlock,
			ModalStatisticsBlock,
			Modal
		},
		computed: {
			opignoMode: function() {
				return this.$store.state.opignoMode;
			},
			currentStep: function() {
				return this.$store.state.user.currentStep;
			},
			auditNotFinished: function() {
				return this.currentStep != "END";
			},
			isFirstOrSecondStep: function() {
				return this.currentStep == "FIRST_STEP" || this.currentStep == "SECOND_STEP";
			},
			currentCriteriaPercentageOfYes: function()  {
				let state = this.$store.state.user;
				if (state.currentStep == 'CRITIC_STEP') {
					if (state.userAnswers['FIRST_STEP'].filter(patientAnswers => patientAnswers[state.currentPosition - 1] == 2 ? 1 : 0).length == state.userAnswers['FIRST_STEP'].length)  {
						if (state.selectedAnswer == -1)	{
							this.$store.dispatch('changeAnswer', 3);
						}
						return 100;
					}
					let nbYes = state.userAnswers['FIRST_STEP'].filter(patientAnswers => patientAnswers[state.currentPosition - 1] == 0 ? 1 : 0).length;
					let nbNo = state.userAnswers['FIRST_STEP'].filter(patientAnswers => patientAnswers[state.currentPosition - 1] == 1 ? 1 : 0).length;
					let res = Math.round((nbYes * 100) / (nbYes + nbNo));
					if (res == 100 && state.selectedAnswer == -1) {
						this.$store.dispatch('changeAnswer', 3);
					}
					return Math.round((nbYes * 100) / (nbYes + nbNo));
				}
				return 0;
			},
		},
		mounted()	{
			// this.$root.$el.style.overflow = 'scroll';
		},
		methods: {
			messageEventHandler(event)	{
				// console.log('iframe', event);
		  //       window.parent.postMessage('success', '*');				
			}
		},
		beforeCreate()  {
			if (!this.$store.state.opignoMode)	{
	            this.$emit('navbarUpdate', {
	                backText: "Retour aux grilles d'audit",
	                pathData: {
	                    name: "InstanceList"
	                }
	            });				
			}
        }
	};
</script>

<style>


</style>
